import { render, staticRenderFns } from "./MotivoVisitaManage.vue?vue&type=template&id=afcaf3fe&scoped=true"
import script from "./MotivoVisitaManage.vue?vue&type=script&lang=js"
export * from "./MotivoVisitaManage.vue?vue&type=script&lang=js"
import style0 from "./MotivoVisitaManage.vue?vue&type=style&index=0&id=afcaf3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcaf3fe",
  null
  
)

export default component.exports